import {
    FETCH_AGENTS_REQUEST,
    FETCH_AGENTS_SUCCESS,
    FETCH_AGENTS_FAILURE,
    CREATE_AGENT_SUCCESS,
    UPDATE_AGENT_SUCCESS,
    DELETE_AGENT_SUCCESS,
    TOGGLE_LOCK_AGENT_SUCCESS
  } from '../actions/agentActions';
  import { PATCH_AGENT_BALANCE_AFTER_TRANSFER } from '../actions/transferBalancePatchActions';
  
  const initialState = {
    agents: [],
    loading: false,
    error: null
  };
  
  const agentReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_AGENTS_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_AGENTS_SUCCESS:
        return { ...state, loading: false, agents: action.payload, error: null };
      case FETCH_AGENTS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_AGENT_SUCCESS:
        if (!action.payload) return state;
        return { ...state, agents: [...state.agents, action.payload] };
      case UPDATE_AGENT_SUCCESS:
        return {
          ...state,
          agents: state.agents.map(agent =>
            agent._id === action.payload._id ? action.payload : agent
          )
        };
      case DELETE_AGENT_SUCCESS:
        return {
          ...state,
          agents: state.agents.filter(agent => agent._id !== action.payload)
        };
      case TOGGLE_LOCK_AGENT_SUCCESS:
        return {
          ...state,
          agents: state.agents.map((agent) =>
            agent._id === action.payload?._id
              ? { ...agent, isLocked: action.payload.isLocked, is_active: action.payload.is_active }
              : agent
          )
        };
      case PATCH_AGENT_BALANCE_AFTER_TRANSFER: {
        const { username, balance } = action.payload;
        if (username == null || balance == null) return state;
        return {
          ...state,
          agents: state.agents.map((a) =>
            a.username === username ? { ...a, balance } : a
          ),
        };
      }
      default:
        return state;
    }
  };
  
  export default agentReducer;